var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('main',[_c('h1',[_vm._v("Partners List")]),_c('ul',{staticClass:"partners-list"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }